export default __webpack_public_path__ + "static/media/04a_fold-19.50b54a58.mp4";